// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37diZ","option":"styles_option__3GK4a","active":"styles_active__19fjm"};